import { Skeleton, Stack, Typography } from "@mui/material";
import { useGetTeam } from "../../../http";
import { Plan } from "../../TeamPages/TeamStrategicMapPage/components";
import { DateTime } from "luxon";
import { useSession } from "../../../hooks";

interface IProps {
  teamName: string;
  teamSlug: string;
}

const TeamStrategicMapReview = (props: IProps) => {
  const { userId } = useSession();
  const { data: team, isLoading: isLoadingTeam } = useGetTeam(props.teamSlug, userId);

  const hasEditPermission = (team?.isAdministrator || team?.isMember) ?? false;

  if (!isLoadingTeam && team && team.planGuid !== null) {
    return (
      <Plan
        teamName={props.teamName}
        teamSlug={props.teamSlug}
        planGuid={team.planGuid}
        headerContent={({ isLoading, plan }) => {
          return isLoading || !plan ? (
            <Stack spacing={0.25} width={"100%"}>
              <Skeleton variant="rectangular" height={25} width={"25%"} />
              <Skeleton variant="rectangular" height={25} width={"100%"} />
            </Stack>
          ) : (
            <Stack spacing={0.25}>
              <Typography variant="h5">Strategic Map</Typography>
              <Typography
                variant="body1"
                title={`Last changed by ${plan.lastModifiedByDisplayName} on ${DateTime.fromISO(plan.lastModifiedUtc, {
                  zone: "utc",
                })
                  .toLocal()
                  .toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS)}`}
              >
                {`Last changed by ${plan.lastModifiedByDisplayName} on ${DateTime.fromISO(plan.lastModifiedUtc, {
                  zone: "utc",
                })
                  .toLocal()
                  .toLocaleString(DateTime.DATE_FULL)}`}
              </Typography>
            </Stack>
          );
        }}
        canEdit={hasEditPermission}
        meetingView
      />
    );
  }

  return null;
};

export { TeamStrategicMapReview };
